import React from 'react';
import { Button } from "@fc/devteam-components-library";
import { useTranslation } from 'react-i18next';

type FormButtonsProps = {
  setCleanForm: () => void
}

const FormButtons = ({setCleanForm}: FormButtonsProps) => {
  const { t } = useTranslation(['myDevices']);
  return (
    <div className="Services__ButtonCtr">
      <div
        className="Button-Dissabled"
        onClick={setCleanForm}
      >
        <Button
          buttontype="button"
          buttontext={t('buttons.cancel')}
        />
      </div>
      <Button
        buttontype="submit"
        buttontext={t('buttons.save')}
      />
    </div>
  );
};

export default FormButtons;
